import { Action } from '@ngrx/store';
import { TAppMasterDatabase } from './app-master-db.reducer';

// Actions
export enum AppMasterDBActionTypes {
  LoadAppMasterDB = '[AppMasterDB] Load App Master',
  FailedAppMasterDBLoad = '[AppMasterDB][FAILED] Fetching Apps from Cache',
  AppMasterDBLoaded = '[AppMasterDB] Apps Loaded from Cache',
  LoadAppMasterDBSettings = '[AppMasterDB][SETTINGS] Load App Master Settings',
  AppMasterDBSettingsLoaded = '[AppMasterDB][SETTINGS] App Master Settings Loaded',
  // Change
  ChangeStation = '[AppMasterDB][SETTINGS] Change Station',
  AppSwitch = '[AppMasterDB][SETTINGS] Change APP',
}

export class LoadAppMasterDB implements Action {
  readonly type = AppMasterDBActionTypes.LoadAppMasterDB;
  constructor() {}
}

export class FailedAppMasterDBLoad implements Action {
  readonly type = AppMasterDBActionTypes.FailedAppMasterDBLoad;
  constructor() {}
}

export class AppMasterDBLoaded implements Action {
  readonly type = AppMasterDBActionTypes.AppMasterDBLoaded;
  constructor(public payload: TAppMasterDatabase) {}
}

export class LoadAppMasterDBSettings implements Action {
  readonly type = AppMasterDBActionTypes.LoadAppMasterDBSettings;
  constructor(public payload: Required<TAppMasterDatabase>['settingsInfo']) {}
}

export class ChangeStation implements Action {
  readonly type = AppMasterDBActionTypes.ChangeStation;
  constructor(public payload: string) {}
}

export class AppSwitch implements Action {
  readonly type = AppMasterDBActionTypes.AppSwitch;
  constructor(public appId: string) {}
}

export type TAppMasterDBActions =
  | LoadAppMasterDB
  | AppMasterDBLoaded
  | FailedAppMasterDBLoad
  | LoadAppMasterDBSettings
  | ChangeStation
  | AppSwitch;
